'use client';

import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';

export default function ToolPageThemeToggle() {
  const { theme, resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setMounted(true), 0);
    return () => clearTimeout(timer);
  }, []);

  if (!mounted || !resolvedTheme) {
    return null;
  }

  const currentTheme = theme === 'system' ? resolvedTheme : theme;
  const isDark = currentTheme !== 'light';

  return (
    <div className="fixed right-4 top-28 z-40">
      <button
        type="button"
        onClick={() => setTheme(isDark ? 'light' : 'dark')}
        className="group relative inline-flex h-12 w-12 items-center justify-center rounded-xl border border-primary/20 bg-card/80 text-foreground backdrop-blur-xl transition-all hover:border-primary/40 hover:scale-110 shadow-lg"
        aria-label="Toggle theme"
      >
        {isDark ? (
          <Sun className="h-5 w-5 text-amber-400 transition-transform group-hover:rotate-45" />
        ) : (
          <Moon className="h-5 w-5 text-indigo-600 transition-transform group-hover:-rotate-12" />
        )}
        <span className="pointer-events-none absolute bottom-full left-1/2 z-50 mb-2 -translate-x-1/2 scale-90 whitespace-nowrap rounded-lg border border-primary/10 bg-card px-3 py-1.5 text-[10px] font-bold text-foreground opacity-0 transition-all group-hover:opacity-100 group-hover:scale-100 shadow-xl">
          Switch to {isDark ? 'Light' : 'Dark'} Mode
          <span className="absolute left-1/2 top-full -mt-1 -translate-x-1/2 border-4 border-transparent border-t-primary/10" aria-hidden="true" />
        </span>
      </button>
    </div>
  );
}
